const COMMON_EN = Object.freeze({
  'common.email': 'Email',
  'common.loading': 'Please wait...',
  'common.go.back': 'Go Back',
  'common.submit': 'Submit',
  'common.confirm': 'Confirm',
  'common.reset': 'Reset',
  'common.search': 'Search',
  'common.cancel': 'Cancel',
  'common.pleaseselect': 'Please select',
  'common.search.keyword': 'Keyword',
  'common.welcome.title': 'Welcome to Qupital',
  'common.welcome.subtitle': 'Your brand new lending experience',
  'common.welcomeback': 'Welcome back {{user.username}}',
  'common.back': 'Back',
  'common.edit': 'Edit',
  'common.btn.convert': 'Convert',
  'common.btn.auto-fill': 'Auto Fill',
  'common.error.pagenotfound': 'Sorry, the page you visited does not exist',
  'common.error.pleasesignin': 'Sorry, please sign in first',
  'common.error.accessdenied': 'Sorry, access denied',
  'common.error.unknown': 'Sorry, a system error occurred',
  'common.application.status': 'Application Status',
  'common.application.no': 'Application No.',
  'common.operation.draftsaved': 'Draft saved',
  'common.operation.submitted': 'Application submitted',
  'common.operation.return': 'The application\'s status has been set to return.',
  'common.operation.review': '{{action}} of {{review}} is submitted',
  'common.operation.migrate': 'Seller is successfully migrated to Qupital Systems',
  'common.operation.created': 'Application created successfully',
  'common.operation.error': 'An error occurred, please contact customer service',
  'common.operation.modify.application.type': 'The type of application {{applicationNumber}} has been changed to {{applicationType}}',
  'common.operation.auto-fill': 'The application {{applicationNumber}} has been filled',
  'common.operation.copy': 'Copied',
});

export { COMMON_EN };
